import React from 'react';

export function CustomEntryField({ testId, placeholder = "Can't find it? Type ANYTHING here — it flows straight into your prompt.", value, onChange, label = "Or type your own" }) {
  return (
    <div className="mt-3 rounded-lg border border-dashed border-pink-500/40 bg-pink-500/5 p-2">
      <div className="text-[10px] uppercase tracking-[0.2em] text-pink-400 mb-1">{label}</div>
      <input
        data-testid={testId}
        className="w-full bg-transparent border-0 outline-none text-sm text-white placeholder:text-zinc-500"
        placeholder={placeholder}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export function FieldLabel({ children }) {
  return <div className="eyebrow mb-2">{children}</div>;
}

export function MultiChipSelect({ options, value = [], onToggle, testIdPrefix }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const label = typeof opt === 'string' ? opt : opt.label;
        const val = typeof opt === 'string' ? opt : opt.id;
        const active = value.includes(val);
        return (
          <button
            key={val}
            type="button"
            className={`chip ${active ? 'active' : ''}`}
            data-testid={`${testIdPrefix}-${val}`.toLowerCase().replace(/[^a-z0-9-]/g, '-')}
            onClick={() => onToggle(val)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export function Section({ title, children, right }) {
  return (
    <section className="rounded-xl chrome-border bg-zinc-900/60 p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-xl">{title}</h3>
        {right}
      </div>
      {children}
    </section>
  );
}

export function SimpleSelect({ testId, value, onChange, options, placeholder = 'Select…' }) {
  return (
    <select
      data-testid={testId}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className="w-full bg-zinc-950 border border-zinc-800 rounded-lg px-3 py-2 text-sm text-zinc-100 focus:border-pink-500 outline-none transition-colors"
    >
      <option value="">{placeholder}</option>
      {options.map((o) => {
        const val = typeof o === 'string' ? o : (o.id || o.value);
        const label = typeof o === 'string' ? o : (o.label || o.name);
        return <option key={val} value={val}>{label}</option>;
      })}
    </select>
  );
}
